import axios from "axios";
import { AccountType } from "shared/types/accounts";

export async function connectThreadsNotificationAccount({
  login,
  profilePictureUrl,
}: {
  login: string;
  profilePictureUrl: string;
}): Promise<AccountType> {
  const {
    data: { data },
  } = await axios.post("/accounts/th", {
    login,
    profilePictureUrl,
    platformType: "TH",
  });
  return data;
}
